import React from 'react';
import { flattenRichText } from 'utils/richTextUtils';
import useBreakpointView from 'utils/useBreakpointView';
import Video from 'components/Core/Video';
import getJustify from 'components/Contentful/ContentfulRow/utils/getJustify';
import RichTextImage from '../RichTextImage';

const RichTextImageMp4 = ({ alignDesktop, alignMobile, fields, ...otherProps }) => {
  const {
    boxShadow,
    caption,
    alt,
    image,
    imageMobile,
    imageWidthDesktop,
    imageWidthMobile,
    styles2,
    enableLightbox,
    bynderDesktopImage,
    bynderMobileImage,
    contentfulUrl,
  } = flattenRichText(fields) || {};
  const isMobile = useBreakpointView(['xs', 'sm']);
  const mobileImage = imageMobile?.file;
  const desktopImage = image?.file;
  let imageToRender;

  if (isMobile) {
    imageToRender = bynderMobileImage
      ? bynderMobileImage[0].thumbnails
      : bynderDesktopImage
      ? bynderDesktopImage[0].thumbnails
      : mobileImage || desktopImage;
  } else {
    imageToRender = bynderDesktopImage
      ? bynderDesktopImage[0].thumbnails
      : bynderMobileImage
      ? bynderMobileImage[0].thumbnails
      : desktopImage || mobileImage;
  }

  const { contentType, url, details, src: bynderSrc } = imageToRender || {};

  if (contentType === 'video/mp4' || contentType === 'video/x-m4v') {
    return (
      <Video
        boxShadow={boxShadow}
        type="preview-only"
        height="300px"
        width="100%"
        mainSrc={url}
        previewSrc={url}
        style={{ position: 'relative', right: '0px', top: '0px' }}
        {...otherProps}
      />
    );
  }

  if ((contentType && contentType.includes('image')) || bynderSrc) {
    const title = image?.title;

    const imageSizes = details?.image;
    const justifyMobile = getJustify(alignMobile);
    const justifyDesktop = getJustify(alignDesktop);

    const {
      marginMobile,
      marginDesktop,
      paddingMobile,
      paddingDesktop,
      widthMobile,
      widthDesktop,
    } = styles2 || {};

    const imageStyles = {
      marginMobile,
      marginDesktop,
      paddingMobile,
      paddingDesktop,
      widthMobile,
      widthDesktop,
    };

    return (
      <RichTextImage
        justifyDesktop={justifyDesktop}
        justifyMobile={justifyMobile}
        alt={alt || title}
        caption={caption}
        imageSizes={imageSizes}
        marginTop="0px"
        boxShadow={boxShadow}
        styles={imageStyles}
        widthDesktop={imageWidthDesktop}
        widthMobile={imageWidthMobile}
        enableLightbox={enableLightbox}
        link={contentfulUrl}
        {...{
          boxShadow,
          image,
          imageMobile,
          imageWidthDesktop,
          imageWidthMobile,
          styles2,
          bynderDesktopImage,
          bynderMobileImage,
        }}
        {...otherProps}
      />
    );
  }

  return null;
};

export default RichTextImageMp4;
